import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, first } from 'rxjs';
import { ClinicOfficeListService } from 'src/shop-manager/services/clinic-office-list.service';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-generate-zip-lookup-table-dialog',
    templateUrl: './generate-zip-lookup-table-dialog.component.html',
    styleUrls: ['./generate-zip-lookup-table-dialog.component.css'],
    standalone: false
})
export class GenerateZipLookupTableDialogComponent
{

  loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)
  countries: string = "";
  countriesUpdated = 0;

  constructor(private dialogRef: MatDialogRef<any>, private clinicOfficeListService: ClinicOfficeListService, private serverValueInterpreterService: ServerValueInterpreterService) { }

  ngOnInit()
  {
    if (this.clinicOfficeListService.countriesToUpdateLookupTable)
    {
      this.clinicOfficeListService.countriesToUpdateLookupTable.value.forEach((l_country, index) =>
      {
        if(Object.keys(COUNTRIES_IDS).includes(l_country)) {
        this.countries += this.serverValueInterpreterService.getFullCountryNameById(l_country as CountryId)
        }
        if (index + 1 < this.clinicOfficeListService.countriesToUpdateLookupTable.value.length) this.countries += ", "
      });

    }
  }

  isDisabledButton(): boolean
  {
    let l_disabled = false
    //????
    return l_disabled
  }

  async onSubmit()
  {
    this.loaded.next(false)

    var l_countriesToUpdate = this.clinicOfficeListService.countriesToUpdateLookupTable.value;
    var l_updateCountryIndex = 0;

    if (this.clinicOfficeListService.countriesToUpdateLookupTable.value)
    {
      this.generateZipLookupTable(l_countriesToUpdate, l_countriesToUpdate.length, l_updateCountryIndex);
    }


  }

  generateZipLookupTable(countries: string[], countriesToUpdateAmount: number, index: number)
  {
    this.clinicOfficeListService.generateZipLookupTable(countries[index]).pipe(first(l_resp => l_resp == true)).subscribe(l_resp =>
    {
      this.countriesUpdated++;
      if (this.countriesUpdated == countriesToUpdateAmount)
      {
        this.loaded.next(l_resp);
        this.clinicOfficeListService.getTimestampsZipCodeRelation();
        this.dialogRef.close('Excelent');
      }
      if (index<countriesToUpdateAmount-1){
        index++;
        this.generateZipLookupTable(countries,countriesToUpdateAmount,index);
      }

    })
  }
}

